import { motion, useReducedMotion } from "framer-motion";
import { LEADS } from "../../constants/testIds";
import { useDeskData } from "../../contexts/DeskDataContext";
import { fadeUp } from "../../lib/motion";
import { LeadTabsBoard } from "../../components/leads/LeadTabsBoard";

// Front Desk/Manager's Lead pipeline — branch-scoped (their own branch only). `LeadTabsBoard`
// (tabs/table/drawer/capture/convert, all in one) is shared verbatim with the Owner Cockpit's
// `/app/leads` — see components/leads/LeadTabsBoard.jsx.
export default function Leads() {
  const { branchId } = useDeskData();
  const reducedMotion = useReducedMotion();

  return (
    <div data-testid={LEADS.page} className="space-y-5">
      <motion.div {...fadeUp(reducedMotion)}>
        <h1 className="text-2xl font-bold" style={{ color: "#141416" }}>Lead Pipeline</h1>
        <p className="text-sm mt-0.5" style={{ color: "#68686E" }}>Track enquiries from first contact through to conversion.</p>
      </motion.div>

      <LeadTabsBoard branchId={branchId} memberDetailPath={(id) => `/desk/members/${id}`} />
    </div>
  );
}
